var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4885_2528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.125 12.3675V14.5208C2.125 14.7192 2.28083 14.875 2.47917 14.875H4.6325C4.72458 14.875 4.81667 14.8396 4.88042 14.7688L12.6154 7.04083L9.95917 4.38458L2.23125 12.1125C2.16042 12.1833 2.125 12.2683 2.125 12.3675ZM14.6696 4.98667C14.9458 4.71042 14.9458 4.26417 14.6696 3.98792L13.0121 2.33042C12.7358 2.05417 12.2896 2.05417 12.0133 2.33042L10.7171 3.62667L13.3733 6.28292L14.6696 4.98667Z",
    fill: "#A3AED0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4885_2528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e49a2008b222b6a43ee2f5994e78c296.svg";
export { ForwardRef as ReactComponent };